import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/julian-hong.png'


const _hoisted_1 = { class: "flex items-center flex-col pb-8" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "flex max-h-14 rounded-full bg-white",
  src: _imports_0,
  alt: "dr julian hong"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", { class: "flex pt-5 pb-2" }, "Dr Julian Hong, Medical Director", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex items-center flex-col space-y-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex bg-white flex-col py-4 w-full max-w-5xl" }, [
    /*#__PURE__*/_createVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createVNode("h2", { class: "w-1/6 text-xl font-semibold w-32 text-center" }, "01"),
      /*#__PURE__*/_createVNode("p", { class: "w-5/6 pl-2 pr-4 text-sm" }, " Answer some basic medical questions to help us understand your needs better. ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "flex bg-white flex-col py-4 w-full max-w-5xl" }, [
    /*#__PURE__*/_createVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createVNode("h2", { class: "w-1/6 text-xl font-semibold w-32 text-center" }, "02"),
      /*#__PURE__*/_createVNode("p", { class: "w-5/6 pl-2 pr-4 text-sm" }, " View and select from our available treatment plans, recommended for you. ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "flex bg-white flex-col py-4 w-full max-w-5xl" }, [
    /*#__PURE__*/_createVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createVNode("h2", { class: "w-1/6 text-xl font-semibold w-32 text-center" }, "03"),
      /*#__PURE__*/_createVNode("p", { class: "w-5/6 pl-2 pr-4 text-sm" }, " If a prescription is required, book a telehealth appointment with us. ")
    ])
  ])
], -1)
const _hoisted_5 = { class: "flex items-center flex-col space-y-3 pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Next = _resolveComponent("Next")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, { class: "text-primary" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Header, {
          title: "How it works",
          showBackButton: false
        }),
        _hoisted_2,
        _hoisted_3
      ]),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Next, {
          text: "Continue →",
          onNext: _ctx.next
        }, null, 8, ["onNext"])
      ])
    ]),
    _: 1
  }))
}